/**
 * ver 0.1
 * author jack
 */
import React from 'react'
import styled from "styled-components";

class DefaultLayer extends React.Component {
    componentDidMount() {
        this.onPopupStyle(false)
    }

    componentWillUnmount() {
        this.onPopupStyle(true)
    }

    onPopupStyle = (state) => {
        if (this.props.pageType === 1) { // 상품 비교 새창일 떄
            document.body.style.overflow = 'hidden'
        } else {
            document.querySelector('#header').style.opacity = state ? 1 : 0
            document.body.style.overflow = state ? 'visible' : 'hidden'
        }
    }

    render() {
        return (
            <BackDrop>
                <WrapperLayer>
                    <WrapperCloseIcon>
                        <CloseIcon className="icon-close btn-layer-pop_clse" onClick={() => this.props.onClose()} ></CloseIcon>
                    </WrapperCloseIcon>
                    <WrapperTitleText >
                        <strong>{this.props.children}</strong>
                    </WrapperTitleText>
                    <LayerButton onClick={() => this.props.onClose()} >
                        확인
                    </LayerButton>
                </WrapperLayer>
            </BackDrop>
            // <table id="lyrPop" className="bgdark">
            //     <tbody><tr><td>
            //         <div className="PopMain artPop" style={{paddingRight:this.props.padding, paddingLeft:this.props.padding}}>
            //             <strong>{this.props.children}</strong>
            //             {/* <font className="clrpont1">파란글씨 클래스clrpont1</font> */}
            //             <div className="popDefBtns">
            //                 <button className="icon-X_close" onClick={() => this.props.onClose()}></button>
            //                 <button className="confBtn" onClick={() => this.props.onClose()}>확인</button>
            //             </div>
            //         </div>
            //     </td></tr></tbody>
            // </table>
        )
    }
}
export default DefaultLayer

const BackDrop = styled.div`
        height: 100%;
        left: 0;
        min-width: 950px;
        position: fixed;
        text-align: center;
        top: 0;
        width: 100%;
        z-index: 220;
        background-color: rgba(0, 0, 0, 0.75);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        font-family: 'Noto Sans KR', "나눔고딕", 'Nanum Gothic', "맑은고딕", 'Malgun Gothic', ‘Apple SD Gothic Neo’, "돋움", dotum, "굴림", gulim, sans-serif;
`

const WrapperLayer = styled.div`
    &&{
        width: 342px;
        min-height: 186px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        padding: 14px 12px;
        box-sizing: border-box;
    }
`


const WrapperCloseIcon = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`


const CloseIcon = styled.button`
    font-size: 31px;
    color: #418DED;
    :hover {
        color: #005796;
    }
`

const WrapperTitleText = styled.div`
    width: 100%;
    font-weight: bold;
    font-size: 22px;
    margin-top: 15px;
    span {
        width: 100%;
        color: #333333;
        font-size: 22px;
        line-height: 38px;

        b {
            color: #3281ED;
        }
    }
`

const LayerButton = styled.button`
    && {
        width: 100px;
        height: 44px;
        background-color: #fff;
        border: 2px solid #418DED;
        color: #418DED;
        font-size: 16px;
        font-weight: bold;
        margin-top: 21px;
        :hover {
            background-color: #F6F6F6;
        }
    }
`




// WEBPACK FOOTER //
// ./src/estimate_list/components/layer/defaultLayer.js